import { FormattedMessage } from '@flipster/i18n';
import { Tooltip } from '@flipster/react/design-system-legacy/tooltip';
import { Dialog, dialog } from '@flipster/react/design-system/dialog';
import InformationCircleIcon from '@flipster/react/icon/generated/InformationCircleIcon';
import { center, flex } from '@flipster/styled-system/patterns';
import { token } from '@flipster/styled-system/tokens';

export const ConvertibleTooltip = () => {
  return (
    <div
      className={flex({
        justify: 'flex-start',
        align: 'center',
        textStyle: 'Legacy/Body2',
        gap: 6,
        mb: 6,
      })}
    >
      <FormattedMessage id='Convert.r250401.Convertible_balance' />
      <Tooltip
        placement='bottom'
        maxWidth={250}
        mobileAlert={() => {
          dialog.open({
            title: {
              label: <FormattedMessage id='Convert.r250401.Convertible_balance' />,
            },
            content: <FormattedMessage id='Convert.r250401.Convertible_balance_tooltip_description' />,
            buttons: {
              primary: <Dialog.Button hierarchy='primary' label={<FormattedMessage id='Common.r250401.Confirm' />} />,
            },
          });
        }}
      >
        <Tooltip.Trigger css={center.raw()}>
          <InformationCircleIcon size={18} color={token('colors.content.default.level-1')} />
        </Tooltip.Trigger>
        <Tooltip.Content>
          <FormattedMessage id='Convert.r250401.Convertible_balance_tooltip_description' />
        </Tooltip.Content>
      </Tooltip>
    </div>
  );
};
